export default __webpack_public_path__ + "img/email-header.jpg";